import { TaggingOptions, configureTagging } from "@walmart/sophia-tagging"
import { EVENTS } from "./constants"
import promotionBannerParser from "./parsers/promotionBannerParser"
import initializeParser from "./parsers/initializeParser"

const config: TaggingOptions = {
	handlers: {
		onPublish: ({ eventName, origin, flowType, data }) => {
			;(window as any).dataLayer.push({
				event: eventName,
				origin,
				flowType,
				dataCollection: data,
				version: "ga4",
			})
		},
	},
	events: {
		[EVENTS.INITIALIZE]: { parser: initializeParser },
		[EVENTS.PROMOTIONBANNER]: { parser: promotionBannerParser },
	},
	features: { base: true },
}

export const logEvent = configureTagging(config)
